<template>
  <div>
    <Header title="个人调课申请"></Header>
    <div class="personalTable">
      <div class="applyInfo">
        <p>{{ list.kcmc }}</p>
        <ul>
          <li>
            班级：<span>{{ list.ktmc }}</span>
          </li>
          <li>
            人数：<span>{{ list.skrs }}</span>
          </li>
          <li>
            调课须知：<span>{{ list.tkxz }}</span>
          </li>
        </ul>
      </div>
      <div class="apply">
        <van-field
          v-model="bgly.mc"
          label="变更理由"
          right-icon="arrow"
          input-align="right"
          placeholder="请点击选择"
          @click="onShow('变更理由', 'bgly')"
          required
          readonly
        />
        <van-field
          v-model="sfytzxs.mc"
          label="是否通知学生"
          right-icon="arrow"
          input-align="right"
          placeholder="请点击选择"
          @click="onShow('是否已通知学生', 'sfytzxs')"
          required
          readonly
        />
        <van-field
          v-model="sfjyxyjs.mc"
          label="是否借用教室"
          right-icon="arrow"
          input-align="right"
          placeholder="请点击选择"
          @click="onShow('是否借用学院教室', 'sfjyxyjs')"
          required
          readonly
        />
        <van-field
          v-model="shr.mc"
          label="审核人"
          right-icon="arrow"
          input-align="right"
          placeholder="请点击选择"
          @click="show1 = true"
          required
          readonly
        />
        <van-field
          v-model="bgqk"
          label="变更情况"
          input-align="right"
          type="textarea"
          placeholder="请点击填写"
          maxlength="500"
          required
          show-word-limit
        />
        <van-field
          v-model="xxly"
          label="详细理由"
          input-align="right"
          type="textarea"
          placeholder="请点击填写"
          maxlength="500"
          required
          show-word-limit
        />
      </div>
      <div class="bottom-btn">
        <button @click="save">提交申请</button>
      </div>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
        @cancel="show = false"
      />
    </van-popup>
    <van-popup v-model="show1" position="bottom">
      <div class="apply-pop">
        <div class="pop-title">
          <i class="close-icon" @click="show1 = false"></i>
          <p>审核人</p>
          <i class="confirm-icon" @click="resetCancel()"></i>
        </div>
        <div class="person">
          <button
            class="per-btn"
            ref="person"
            v-for="(item, index) in shrList"
            @click="personTap($event, index)"
            :key="item.id"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Api } from "../../../../../utils/axios";

export default {
  data() {
    return {
      show: false,
      show1: false,
      shr: {},
      bgly: {},
      sfytzxs: {},
      sfjyxyjs: {},
      bgqk: "",
      xxly: "",
      shrList: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ],
      columns: {},
      valueList: {
        label: "",
        value: "",
        item: ""
      },
      list: []
    };
  },
  created() {
    this.list = JSON.parse(this.$route.query.list);
    this.getList();
    console.log(this.list);
  },
  methods: {
    async save() {
      if (
        this.bgly.dm == undefined ||
        this.sfytzxs.dm == undefined ||
        this.sfjyxyjs.dm == undefined ||
        this.shr.dm == undefined ||
        this.bgqk == "" ||
        this.xxly == "" 
      ) {
        this.$toast.fail("请完善必填信息！");
        return;
      }
      const res = await Api.savetksq({
        jx0404id: this.list.jx0404id,
        xnxq01id: this.list.xnxqid,
        bgqk: this.bgqk,
        xxly: this.xxly,
        bgly: this.bgly.dm,
        sfytzxs: this.sfytzxs.dm,
        sfjyxyjs: this.sfjyxyjs.dm,
        userids:this.shr.dm
      });
      if (res.code === "1") {
        this.$toast.success("提交申请");
        setTimeout(() => {
          this.$router.replace("/personalTable/index");
        }, 1500);
      } else {
        return;
      }
    },
    async getList() {
      const res = await Api.totksqadd({
        jx0404id: this.list.jx0404id
      });
      this.columns.bgly = res.bglydata.map((item, index) => {
        return {
          value: item.dm,
          text: item.dmmc
        };
      });
      this.columns.sfytzxs = [
        {
          value: "0",
          text: "是"
        },
        {
          value: "1",
          text: "否"
        }
      ];
      this.columns.sfjyxyjs = [
        {
          value: "0",
          text: "是"
        },
        {
          value: "1",
          text: "否"
        }
      ];
    },
    // 弹出选择器
    onShow(label, value) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    onConfirm(value, index, value1) {
      this.show = false;
      this[value1].mc = value.text;
      this[value1].dm = value.value;
    },
    // 获取审核人列表
    async getShr() {
      let concatList2 = [];
      let concatList3 = [];
      const params = {
        ywcode: "0092",
        ywid: ''
      };
      const res = await Api.selectReviewerApi(params);
      res.data.forEach((item, index) => {
        concatList2[index] = {
          name: item.userrealname,
          id: item.userid,
          isBtn: 0
        };
      });
      this.shrList = this.shrList.concat(concatList2);
    },
    // 审核人弹框中的按钮选择
    personTap(e, res) {
      let strList = [];
      let idList = [];
      if (this.shrList[res].isBtn == 0) {
        this.shrList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.shrList[res].isBtn == 1) {
        this.shrList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.shrList) {
        if (this.shrList[res].name == "全部") {
          this.shrList[i].isBtn = 0;
          this.shrList[res].isBtn = 1;
          this.$refs.person[res].className = "cur";
          this.$refs.person[i].className = "per-btn";
        } else {
          this.shrList[0].isBtn = 0;
          this.$refs.person[0].className = "per-btn";
        }
        if (this.shrList[i].isBtn == 1) {
          strList = strList.concat(this.shrList[i].name);
          idList = idList.concat(this.shrList[i].id);
        }
      }
      this.reset = strList.toString();
      this.resetId = idList.toString();
    },
    // 审核人选择完后点击确认
    resetCancel() {
      this.show1 = false;
      this.shr.mc = this.reset;
      this.shr.dm = this.resetId;
    }
  }
};
</script>
<style lang="less">
.personalTable {
  .van-tabs__content--animated {
    height: 75vh;
    overflow: auto;
  }
  .van-tabs--line .van-tabs__wrap {
    border-bottom: 1px solid #f4f4f4;
    .van-tab--active {
      .van-tab__text--ellipsis {
        color: #212f6e !important;
      }
    }
    .van-tab__text--ellipsis {
      width: 56px;
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #8f95b5;
      letter-spacing: 0;
    }
    .van-tabs__line {
      background-color: #7469f8 !important;
      width: 25px;
      height: 3px;
      border-radius: 1.5px;
    }
  }
  .applyInfo {
    width: 100%;
    height: 100%;
    padding: 7% 5% 0 5%;
    p {
      height: 25px;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #212f6e;
      letter-spacing: 0;
      margin-bottom: 2%;
      font-weight: bolder;
      margin-bottom: 8px;
    }
    ul li {
      font-family: PingFangSC-Light;
      font-size: 14px;
      color: #757da3;
      letter-spacing: 0;
      margin-bottom: 2%;

      span {
        font-weight: bolder;
        word-wrap: break-word;
        display: inline-block;
        width: 80%;
      }
    }
    ul li:last-child {
      display: flex;
      align-items: stretch;
    }
  }
  .apply {
    padding: 0 3% 0;
    .van-cell {
      border-bottom: 1px solid #f4f4f4;
    }
    .van-cell::after {
      display: none;
    }
    .van-field__label {
      width: 7.2em;
      span {
        width: 96px !important;
        display: inline-block;
      }
    }
    .van-cell.van-field .van-cell__title.van-field__label > span {
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
    }
    .van-field__control::-webkit-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      font-weight: normal;
      text-align: right;
    }
    .van-field__control::-moz-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      font-weight: normal;
      letter-spacing: 0;
      text-align: right;
    }
    .van-field__control::-ms-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      font-weight: normal;
      text-align: right;
    }
    .van-field__control {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
      text-align: right;
      font-weight: bolder;
    }
    .van-icon-arrow {
      color: #dfe0e6;
      font-weight: bolder;
      font-size: 14px;
    }
    .van-cell__title,
    .van-cell.van-field .van-cell__title.van-field__label > span {
      width: 64px;
      height: 22px;
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
    }
    .van-icon-eye-o,
    .van-icon-eye,
    .van-icon-smile-o,
    .van-icon-smile,
    .van-icon-location,
    .van-icon-location-o,
    .van-icon-like,
    .van-icon-like-o,
    .van-icon-fire-o,
    .van-icon-fire,
    .van-icon-setting {
      font-family: "iconfont" !important;
      font-size: 22px;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      color: #212f6e;
    }
    .van-icon-eye-o::before {
      content: "\e6ba";
    }
    .van-icon-eye::before {
      content: "\e6b8";
    }
    .van-icon-smile-o::before {
      content: "\e6bd";
    }
    .van-icon-smile::before {
      content: "\e6c1";
    }
    .van-icon-location::before {
      content: "\e6b4";
    }
    .van-icon-location-o::before {
      content: "\e6bb";
    }
    .van-icon-like::before {
      content: "\e6be";
    }
    .van-icon-like-o::before {
      content: "\e6db";
    }
    .van-icon-fire-o::before {
      content: "\e6e7";
    }
    .van-icon-fire::before {
      content: "\e6de";
    }
    .van-icon-setting::before {
      content: "\e6df";
    }

    .van-field__control::-webkit-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      text-align: right;
    }
    .van-field__control::-moz-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      text-align: right;
    }
    .van-field__control::-ms-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      text-align: right;
    }
  }
  .applyList {
    .list {
      padding: 5% 5% 0;
      .list-item {
        background: #f8f8f8;
        border-radius: 5px;
        margin-bottom: 5%;
        padding: 3% 0 3% 6%;
        position: relative;
        p {
          height: 22px;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #212f6e;
          letter-spacing: 0;
          margin-bottom: 2%;
        }
        ul li {
          height: 17px;
          font-family: PingFangSC-Light;
          font-size: 12px;
          color: #757da3;
          letter-spacing: 0;
          margin-bottom: 1%;
        }
        span {
          height: 20px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          letter-spacing: 0;
          position: absolute;
          top: calc(50% - 10px);
          right: 5%;
          font-weight: bolder;
        }
        .shzClass {
          color: #7469f8;
        }
        .btgClass {
          color: #f86969;
        }
        .ytgClass {
          color: #12ddd6;
        }
        .dssClass {
          color: #757da3;
        }
      }
    }
    .van-ellipsis {
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 15px;
      color: #212f6e;
      letter-spacing: 0;
      font-weight: bolder;
    }
    .van-cell {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #212f6e;
      letter-spacing: 0;
    }
    .van-dropdown-menu {
      border-bottom: 1px solid #f4f4f4;

      .van-dropdown-menu__bar {
        box-shadow: none;
      }
      .van-dropdown-item {
        position: static;
        height: 1000px;

        .van-overlay {
          top: 49px;
          left: 100%;
        }
        .van-popup--top {
          top: 49px;
          left: 100%;
        }
      }
    }
  }

  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    padding: 0 5%;
    background: #fff;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
/* 审核人 */
.close-icon {
  background: url(../../../../../../static/img/close.png) no-repeat center;
}
.confirm-icon {
  background: url(../../../../../../static/img/confirm.png) no-repeat center;
}
.pop-title i {
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
  padding: 10px;
}
.pop-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.person {
  padding: 15px;
}
.person button {
  border-radius: 3px;
  padding: 5px 15px;
  margin-right: 12px;
  margin-bottom: 10px;
}
.apply-pop .person .per-btn {
  background-color: #ecedfd;
  color: #7469f8;
}
.person .cur {
  background-color: #7469f8;
  color: #ecedfd;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/exchangeK/personalTable/apply.vue